<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="edit-version-box">
    <el-dialog title="" :visible="true" :before-close="closeBox">
      <div v-if="id == 0">
        <el-form :model="form" label-width="100px">
          <el-form-item label="系统类型:">
            <el-select
              v-model="form.sys_type"
              placeholder="系统类型"
              style="width: 50%"
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="后台ERP"></el-option>
              <el-option value="2" label="仓储APP"></el-option>
              <el-option value="3" label="代采APP"></el-option>
              <el-option value="4" label="YS-APP"></el-option>
              <el-option label="朱雀手持" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否强制更新:">
            <el-select
              v-model="form.is_force_update"
              placeholder="是否强制更新"
              style="width: 50%"
            >
              <el-option value="0" label="否"></el-option>
              <el-option value="1" label="是"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本号:">
            <el-input
              v-model="form.version"
              style="width: 50%"
              placeholder="版本号"
            ></el-input>
          </el-form-item>
          <el-form-item label="更新链接:">
            <el-input
              v-model="form.update_url"
              style="width: 50%"
              placeholder="更新链接"
            ></el-input>
            <el-upload
              ref="upload"
              :action="uploadActionUrl"
              :data="uploadData"
              :on-success="uploadSuccess"
              :before-upload="beforeUpload"
              :limit="1"
            >
              <el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="更新说明:">
            <el-input
              v-model="form.update_desc"
              class="version_box"
              type="textarea"
              style="width: 50%; height: 180px"
              placeholder="更新说明"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 25%" @click="closeBox">取消</el-button>
            <el-button type="success" style="width: 25%" @click="submitData"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div v-if="id > 0">
        <el-form :model="form" label-width="100px">
          <el-form-item label="系统类型:">
            <el-select
              v-model="form.sys_type"
              disabled
              placeholder="系统类型"
              style="width: 50%"
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="后台ERP"></el-option>
              <el-option value="2" label="仓储APP"></el-option>
              <el-option value="3" label="代采APP"></el-option>
              <el-option value="4" label="YS-APP"></el-option>
              <el-option label="朱雀手持" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否强制更新:">
            <el-select
              v-model="form.is_force_update"
              placeholder="是否强制更新"
              style="width: 50%"
            >
              <el-option value="0" label="否"></el-option>
              <el-option value="1" label="是"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本号:">
            <el-input
              v-model="form.version"
              style="width: 50%"
              placeholder="版本号"
            ></el-input>
          </el-form-item>
          <el-form-item label="更新链接:">
            <el-input
              v-model="form.update_url"
              style="width: 50%"
              placeholder="更新链接"
            ></el-input>
            <el-upload
              ref="upload"
              :action="action"
              :limit="1"
              :on-success="uploadSuccess"
              :auto-upload="true"
              with-credentials
            >
            </el-upload>
          </el-form-item>
          <el-form-item label="更新说明:">
            <el-input
              v-model="form.update_desc"
              class="version_box"
              type="textarea"
              style="width: 50%; height: 180px"
              placeholder="更新说明"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 25%" @click="closeBox">取消</el-button>
            <el-button type="success" style="width: 25%" @click="submitData"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";
import Global_ from "../../../components/Global";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        update_url: "",
      },
      fullscreenLoading: false,
      tokenUrl: "/open/Merchants/getObsUploadData",
      uploadData: {
        key: "",
        "content-type": "",
        policy: "",
        AccessKeyId: "",
        signature: "",
        success_action_status: "",
        domain: "",
        bucket: "",
      },
      uploadPath: "",
      uploadActionUrl: "",
      uploadHeaders: { "Content-Type": "multipart/form-data" },
      origin: Global_.origin,
      action: `${apiBaseURL}/erp/common/erpUploadFile`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        console.log(key);
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.getToken();
      if (this.id < 1) {
        return false;
      }
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Setting/versionDetail", { id: this.id })
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          console.log(result.data);
          this.form = result.data.data;
        })
        .catch((err) => {});
    },
    submitData() {
      this.fullscreenLoading = true;
      this.form.id = this.id;
      this.$http
        .post("/erp/Setting/saveVersion", this.filteredForm)
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.$message.success("操作成功");
          this.closeBox();
        })
        .catch((err) => {});
    },
    uploadSuccess(res, file, fileList) {
      const img = `${this.origin}/${this.uploadData.key}`;
      this.form.update_url = img;
    },
    beforeUpload(file, fileList) {
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 30) {
        this.$message.error("图片过大，请上传小于30M的文件");
        return false;
      }
      // 赋值上传文件
      const time = new Date();
      const date = `${time.getFullYear()}${
        time.getMonth() + 1 < 9
          ? `0${time.getMonth().toString()}`
          : time.getMonth()
      }${time.getDate()}${time.getTime()}`;
      const year = `${time.getFullYear()}`;
      const month = `${
        time.getMonth() + 1 < 9
          ? `0${time.getMonth().toString()}`
          : time.getMonth()
      }`;
      const { name } = file;
      const prev = md5(date + name.split(".")[0]);
      const next = name.split(".")[name.split(".").length - 1];
      this.uploadData.key = `${
        this.uploadPath + year
      }/${month}/${prev}.${next}`;
      this.uploadData["content-type"] = "";
    },
    getToken() {
      this.$http.get(this.tokenUrl).then((res) => {
        if (res.data.code == 200) {
          const r = res.data.data;
          this.uploadData.AccessKeyId = r.uptoken.access_key_id;
          this.uploadData.domain = r.uptoken.domain;
          this.uploadData.policy = r.uptoken.policy;
          this.uploadData.signature = r.uptoken.signature;
          this.uploadData.success_action_status =
            r.uptoken.success_action_status;
          this.uploadData.bucket = r.bucket_name;
          const endPoint = r.endpoint;
          this.uploadActionUrl = `https://${this.uploadData.bucket}.${endPoint}/`;
          this.uploadPath = "obs/erp/version_upload/";
        } else {
          return false;
        }
      });
    },
    closeBox() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped>
.bottom-buttom {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/VersionInfo.vue